// extracted by mini-css-extract-plugin
export default {"checkboxContainer":"ChatHistory_checkboxContainer__H5Fe2","checkmark":"ChatHistory_checkmark__PgXkq","sharedocCntainer":"ChatHistory_sharedocCntainer__97SIs"};